import styled from 'styled-components';

interface BitButtonWrapperProps {
  variant?: 'primary' | 'secondary';
}

export const BitButtonWrapper = styled.button<BitButtonWrapperProps>`
  display: flex;
  align-items: center;

  width: fit-content;
  height: fit-content;

  padding: 8px 16px;
  gap: 6px;

  border-radius: 8px;
  font: 700 0.9rem/1.1rem 'Roboto', sans-serif;
  background: ${({ theme, variant }) => {
    switch (variant) {
      case 'primary':
        return theme.themePrimary;
      case 'secondary':
        return 'transparent';
      default:
        return theme.themePrimary;
    }
  }};
  border: 1px solid ${({ theme }) => theme.themePrimary};
  color: ${({ theme, variant }) => {
    switch (variant) {
      case 'primary':
        return '#fff';
      case 'secondary':
        return theme.themePrimary;
      default:
        return '#fff';
    }
  }};
  cursor: pointer;

  &:hover:not(:disabled) {
    color: #fff;
    background: ${({ theme }) => theme.themeSecondary};
    border: 1px solid ${({ theme }) => theme.themeSecondary};
    transition: all 0.3s ease;
  }
  &:disabled {
    cursor: not-allowed;
  }
`;
